<script lang="ts">
  import { toPersianDigits } from '@clinic/money-date';
  import { Boxes } from '@lucide/svelte';
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { fa } from '../../../shared/i18n/fa';
  import { FollowUpRow } from '../../../shared/ui';
  import { useInventoryAlerts } from '../api/inventory-api';
  import { jalaliExpiry, qty } from '../lib/bits';

  /** Home card: the items running low and the batches close to expiry, the first few by name (BR-09, BR-10). */
  const SHOWN = 3;
  const org = useOrg();
  const alerts = useInventoryAlerts(org.orgId);
  const low = $derived(alerts.data?.lowStock ?? []);
  const expiring = $derived(alerts.data?.expiring ?? []);
</script>

<FollowUpRow
  to={`/o/${org.orgId}/inventory?tab=alerts`}
  title={fa.nav.inventory}
  Icon={Boxes}
  attention={low.length + expiring.length > 0}
  loading={alerts.isPending}
  error={alerts.error}
  onRetry={() => void alerts.refetch()}
  linkLabel={fa.home.inventoryOpen}
  testid="home-inventory"
>
  {#if low.length + expiring.length === 0}
    <p class="text-text-3">{fa.home.inventoryCalm}</p>
  {:else}
    {#if low.length > 0}
      <p class="mt-1 font-medium text-text">{fa.home.inventoryLow}</p>
      <ul>
        {#each low.slice(0, SHOWN) as i (i.itemId)}
          <li class="flex justify-between gap-2"><span class="truncate">{i.name}</span><span class="shrink-0 tabular-nums text-text-3">{qty(i.usableOnHand, i.unit)}</span></li>
        {/each}
      </ul>
      {#if low.length > SHOWN}<p class="text-xs text-text-3">{fa.home.andMore(toPersianDigits(low.length - SHOWN))}</p>{/if}
    {/if}
    {#if expiring.length > 0}
      <p class="mt-1 font-medium text-text">{fa.home.inventoryExpiring}</p>
      <ul>
        {#each expiring.slice(0, SHOWN) as b (b.batchId)}
          <li class="flex justify-between gap-2"><span class="truncate">{b.itemName}</span><span class="shrink-0 tabular-nums text-text-3">{jalaliExpiry(b.expiryDate)}</span></li>
        {/each}
      </ul>
      {#if expiring.length > SHOWN}<p class="text-xs text-text-3">{fa.home.andMore(toPersianDigits(expiring.length - SHOWN))}</p>{/if}
    {/if}
  {/if}
</FollowUpRow>
